import React from 'react';

import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import DatePicker from 'material-ui/DatePicker';
import TimePicker from 'material-ui/TimePicker';
import Select from 'react-select'

import Box from '../ui/Box';
var KiotSpinner = null

import DataService from '../../services/DataService'; var ds = DataService;
import LocalStorageService from '../../services/LocalStorageService'; var ls = LocalStorageService;
import Helper from '../../services/Helper'; var help = Helper

export default class CheckOut extends React.Component {
  constructor(props) {
    super(props);
    let x = new Date();
    this.state = {
      room_num: -1,
      room_id: null,
      ch_out_time: new Date(),
      all_rooms: [],
      spinner: null,
      dialog: {
        open: false,
        head: 'Dude',
        body: 'This is working',
        actions: [
          <FlatButton
            label="Okay"
            primary
            onClick={this.closeDialog.bind(this)}
          />
        ]
      }
    };

    this.getAllRooms();
  }

  closeDialog() {
    this.setState({
      dialog: {
        head: '',
        body: '',
        open: false,
        actions: []
      }
    })

  }

  getAllRooms() {
    let user = ls.getUserDetails()
    if (user.hotel_id) {
      ds.getAllRooms(user.hotel_id,
        data => {
          if (data && data.length) {
            for (let i of data) {
              i.label = i.hotel_room_id ? i.hotel_room_id.name : '';
              i.value = i._id;
            }
          }
          this.setState({
            all_rooms: data
          })
        }, error => {
          console.log(error);
        }
      );
    }
  }

  handleChanges(e) {
    this.setState({
      [e.target.name]: e.target.value
    });
  }

  checkoutCustomer(e) {
    e.preventDefault()
    if (this.validated()) {
      this.setState({
        spinner: <KiotSpinner />
      })
      let x = new Date(this.state.ch_out_time);
      ds.postCheckout({
        "guestUserId": this.state.room_num,
        "check_out_time": x.getTime(),
        "room_id": this.state.room_id
      }, data => {

        let dialog = {
          open: true,
          head: 'Success',
          body: "Check-out Done",
          actions: [
            <FlatButton
              label="Okay"
              primary
              onClick={this.closeDialog.bind(this)}
            />
          ]
        }
        this.setState({
          room_num: -1,
          ch_out_time: new Date(),
          check_out_time: "",
          spinner: null,
          dialog: dialog
        });
      }, err => {
        this.setState({
          spinner: null
        });
      });
    }
  }

  refreshTable() {
    this.getAllRooms();
  }

  validated() {
    let dialog;
    let flag = true;
    if (!this.state.room_num || this.state.room_num == -1) {
      dialog = {
        open: true,
        head: 'No Room Selected',
        body: "Select a room to check-in",
        actions: [
          <FlatButton
            label="Okay"
            primary
            onClick={this.closeDialog.bind(this)}
          />
        ]
      }
      flag = false;

    } else {
      try {
        let x = new Date(this.state.ch_out_time);
        if (!x || x == 'Invalid Date') {
          dialog = {
            open: true,
            head: 'Invalid Time',
            body: "Select a valid time for check-out",
            actions: [
              <FlatButton
                label="Okay"
                primary
                onClick={this.closeDialog.bind(this)}
              />
            ]
          }
          flag = false;
        }
      } catch (err) {
        dialog = {
          open: true,
          head: 'Invalid Time',
          body: "Select a valid time for check-out",
          actions: [
            <FlatButton
              label="Okay"
              primary
              onClick={this.closeDialog.bind(this)}
            />
          ]
        }
        flag = false;
      }
    }
    if (!flag) {
      this.setState({
        dialog: dialog
      });
    }
    return flag;
  }

  render() {
    return (
      <Box header='Check-out'>
        <Dialog
          title={this.state.dialog.head}
          autoScrollBodyContent={true}
          actions={this.state.dialog.actions}
          modal={false}
          open={this.state.dialog.open}
          onRequestClose={this.closeDialog.bind(this)}
        >
          {this.state.dialog.body || 'NA'}
        </Dialog>

        <div>
          <div>
            <form onSubmit={this.checkoutCustomer.bind(this)}>
              <fieldset>
                <section>
                  <Select
                    id="room_numid"
                    ref={(ref) => { this.select = ref; }}
                    onBlurResetsInput={false}
                    onSelectResetsInput={false}
                    options={this.state.all_rooms}
                    simpleValue
                    clearable={true}
                    name="room_num"
                    disabled={false}
                    value={this.state.room_num}
                    onChange={(newValue) => {
                      // console.log(newValue);
                      for (let i of this.state.all_rooms) {
                        if (i.value == newValue) {
                          this.setState({
                            room_id: i.hotel_room_id._id
                          })
                          break;
                        }
                      }
                      this.setState({
                        room_num: newValue,
                      })
                    }}
                    searchable={true}
                    placeholder="Room Number"
                    style={{ marginBottom: "15px" }}
                  />
                </section>

                <section>
                  <div className="false-placeholder">Check-out Date & Time</div>

                  <DatePicker
                    hintText="Check-out Date"
                    container="inline"
                    name="ch_out_time"
                    className="col-sm-5 w-100"
                    value={this.state.ch_out_time}
                    autoOk
                    style={{
                      maxWidth: '50%'
                    }}
                    onChange={(e, value) => {
                      this.setState({
                        ch_out_time: value
                      })
                    }} 
                  />
                    
                  <TimePicker
                    format="ampm"
                    autoOk
                    hintText="Check-out Time"
                    className="col-sm-5 w-100"
                    value={this.state.ch_out_time}
                    onChange={(e, value) => {
                      this.setState({
                        ch_out_time: value
                      })
                    }}
                  />
                </section>
              </fieldset>

              <div className="mt-4vw align-right">
                <RaisedButton
                  label="Check-out"
                  primary
                  type="submit"
                />
              </div>
            </form>

          </div>
        </div>
      </Box>
    )
  }
}


// WEBPACK FOOTER //
// ./components/customers/Checkout.js